<script lang="ts">
import FicheTestPaies from '@/generated/fiches/FicheTestPaies.vue';
import { Extended } from '@/framework/base/classes/Schema';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheTestPaies,
  methods: {
    isDisplayed(value: string): boolean {
      if (this.support && this.support.id < 0 && value == 'PARAMETRES_PAIE') {
        this.setExtended(new Extended('PARAMETRES_PAIE', this.fiche, true));
      }
      return true;
    }
  }
})

</script>
